import { LasmooConfigUIModel } from "src/store/models/ui/lamoss/config";

export const encooLamossUIModels = {
  config: LasmooConfigUIModel,
};
